const Logo = () => {
  return (
    <div className="flex items-center flex-nowrap overflow-x-hidden gap-x-[10px] text-[20px] justify-center h-[100%]">
      <img src="/LOGO.svg" alt="No Image" height={40} />
    </div>
  );
};

export default Logo;
